module.exports = __webpack_public_path__ + "img/en.73419f5f.png";